import dashboard from '@/views/dashboard/rouConfig';
import BusinessStatus from '@/views/BusinessStatus/rouConfig';
import MenuQuery from '@/views/MenuQuery/rouConfig';
import maintenance from '@/views/maintenance/rouConfig';
import reserve from '@/views/reserve/rouConfig';
import reportForm from '@/views/reportForm/rouConfig';
import breakfast from '@/views/breakfast/rouConfig';

// import $axios from '../../request/$axios' // 需要拦截请求
// import api from '../../API'

const allRouters = [
  { name: '台位', list: dashboard },
  // { name: '菜品维护', list: maintenance },
  { name: '餐单查询', list: MenuQuery },
  // { name: '营业状况', list: BusinessStatus },
  { name: '预订', list: reserve },
  { name: '报表', list: reportForm },
  { name: '自助', list: breakfast },
];

const returnList = function (arr) {
  return arr.map(e => {
    return { name: e.meta.name, path: e.name };
    // return Object.assign({ path: e.name }, e.meta)
    // return e.path = e.name
  });
};

const routerMetas = {
  namespaced: true,
  state: {
    routerMetas: [], //所有要展示的菜单
    defaultActive: '', //当前选中的菜单
  },
  mutations: {
    setDefaultActive(state, val) {
      console.log('vuex', val);
      // state.defaultActive = '';
      state.defaultActive = val;
    },
    setRouterMetas(state, val) {
      state.routerMetas = val;
    },
  },
  actions: {
    async setDefaultActive(context) {
      //下面部分暂时放开  仅供静态页面使用
      let val = [
        ...allRouters.map(e => {
          return { name: e.name, list: returnList(e.list) };
        }),
      ];
      console.log(window.location.hash);
      let a = window.location.hash.slice(2);
      context.commit('setRouterMetas', val);
      if (a == 'dashboard') {
        context.commit('setDefaultActive', '台位');
      } else if (a == 'maintenance') {
        context.commit('setDefaultActive', '菜品维护');
      } else if (a == 'MenuQuery') {
        context.commit('setDefaultActive', '餐单查询');
      } else if (a == 'reserve') {
        context.commit('setDefaultActive', '预订');
      } else if (a == 'reportForm') {
        context.commit('setDefaultActive', '报表');
      } else if (a == 'breakfast') {
        context.commit('setDefaultActive', '自助');
      }
    },
  },
};

export default routerMetas;
